module.exports = __webpack_public_path__ + "fonts/Inter-300-vietnamese40.5fc7f74.woff2";